/* eslint-disable no-unused-vars */
<template>
  <div>
    <template v-if="!isAuthenticated()">
      <b-button
        pill
        variant="outline-secondary"
        class="btn-theme d-flex align-itens-center align-self-center justify-content-center"
        @click="dark"
        :title="getThemeLabel"
        ><i :class="toggleThemeIcon"></i>
      </b-button>
    </template>
    <template v-else>
      <div class="dont-print cel-user-account">
        <div v-click-outside="hide">
          <img
            :src="user.photo"
            alt="Foto do usuário"
            class="user-photo"
            @click="openMenu"
          />
          <span class="sr-only">Menu do usuário</span>

          <transition name="slide-fade">
            <div class="user-menu" v-if="showMenu">
              <div class="header no-gutters">
                <img
                  :src="user.photo"
                  alt="Foto do usuário"
                  class="user-photo-menu"
                />
                <div class="id-container">
                  <div class="username">{{ nomeUsuario() }}</div>
                </div>
              </div>
              <div class="user-menu-body">
                <ul>
                  <li class="float-left w-100">
                    <a class="link" @click="perfil">
                      <div class="i-block float-left">
                        <i class="fas fa-id-badge"></i>
                      </div>
                      <p style="float: left">Perfil</p>
                    </a>
                  </li>
                  <li class="float-left w-100">
                    <a class="link" @click="dark">
                      <div class="i-block float-left" v-show="!darkTheme">
                        <i class="fas fa-moon"></i>
                      </div>
                      <div class="i-block float-left" v-show="darkTheme">
                        <i class="fas fa-sun"></i>
                      </div>
                        <p class="float-left">Tema {{ toggleThemeLabel }}</p>
                    </a>
                  </li>
                  <li class="float-left w-100">
                    <a class="link" @click="sair">
                      <div class="i-block float-left">
                        <i class="fas fa-sign-out-alt"></i>
                      </div>
                      <p class="float-left">Sair</p>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
// eslint-disable-next-line no-unused-vars
import store from '@/store/store'
import apiCentralSeguranca from '@/api/centralseguranca'
import { mediaBreakpoint } from '@/assets/defs.js'

export default {
  name: 'UserAccount',
  data () {
    return {
      darkTheme: this.$store.getters.getTheme === 'dark',
      showMenu: false,
      user: {
        name: 'Usuário de testes',
        profile: 'Administradores',
        photo: require('@/assets/images/user-photo.png')
      }
    }
  },
  methods: {
    print () {
      window.print()
    },
    isAuthenticated () {
      return store.getters.isAuthenticated
    },
    openMenu () {
      if (screen.width <= mediaBreakpoint.sm) {
        this.$store.commit('setSidebar', 'sidebar-contracted')
        this.$store.commit('setUserMenu', true)
      }
      this.showMenu = !this.showMenu
    },
    hide () {
      this.showMenu = false
    },
    sair () {
      store.dispatch('authLogout');
      this.showMenu = false
      window.location.href = apiCentralSeguranca.authorizeUrl + '&force_login=true'
    },
    dark () {
      let theme = this.$store.getters.getTheme === '' ? 'dark' : ''
      this.darkTheme = theme === 'dark'
      this.$store.commit('setTheme', theme)
      this.hide()
    },
    perfil () {
      window.open(process.env.VUE_APP_PERFIL_URL, '_blank')
    },
    nomeUsuario () {
      if (store.getters.isAuthenticated) {
        this.$store.dispatch("obterCidadao");
        let cidadao = (this.$store.getters.getCidadao);
        return cidadao.nome;
      } else {
        return this.user.name
      }
    }
  },
  computed: {
    toggleThemeLabel () {
      return this.darkTheme ? 'Padrão' : 'Escuro'
    },
    toggleThemeIcon () {
      return this.darkTheme ? 'fas fa-sun' : 'fas fa-moon'
    },
    getThemeLabel () {
      return 'Alternar para o Tema ' + this.toggleThemeLabel
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>

</style>
